import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SubmitPushToCardTransfer = gql`
  mutation SubmitPushToCardTransfer(
    $idempotencyId: IdempotencyToken!
    $input: SubmitPushToCardTransferInput!
  ) {
    submitPushToCardTransfer(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on SubmitPushToCardTransferSuccess {
        transferId
        status
        tileIdsToRefresh
      }
      ... on SubmitPushToCardTransferError {
        ...error
        errorCode
      }
    }
  }
  ${error}
`;
export default SubmitPushToCardTransfer;
